/**
 * Enum representing different filebox item statuses.
 */
export enum FileboxStatusEnum {
	/**
	 * Represents a filebox item that is pending delivery.
	 */
	PENDING = 'pending',

	/**
	 * Represents a filebox item that has been leased for synchronization.
	 */
	LEASED = 'leased',

	/**
	 * Represents a filebox item that has been successfully synchronized.
	 */
	SYNCHRONIZED = 'synchronized',

	/**
	 * Represents a filebox item that has failed to be synchronized during the latest attempt.
	 */
	FAILED = 'failed',

	/**
	 * Represents a filebox item that has failed all synchronization attempts.
	 */
	DEAD_LETTERED = 'dead_lettered',
}
